export default __webpack_public_path__ + "static/media/eye_on.a054075a.svg";